<template>
  <vs-popup class="user-edit-popup"
            id="popup"
            title="DOWNLOAD FORECAST DOCUMENT"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form autocomplete="off" @submit.prevent="handleSubmit(downloadExcel)">
        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/3 w-full md:mb-0">
              <small class="label">Customer</small>
              <v-select :clearable="false" name="customers" placeholder="" label="company_name"
                        v-model="customerId"
                        :options="customers"
                        :reduce="option => option.id"
              />
          </div>
          <div class="vx-col md:w-1/3 w-full md:mb-0">
              <small class="label">Customer Lead</small>
              <v-select :clearable="false" name="customers" placeholder="" label="name"
                        v-model="customerLeadId"
                        :options="customer_lead_list"
                        :reduce="option => option.value"
              />
          </div>
          <div class="vx-col md:w-1/3 w-full md:mb-0">
              <small class="label">Formulation</small>
              <v-select :clearable="false" name="formulations" placeholder="" label="formulation_code"
                        v-model="formulationId"
                        :options="formulations"
                        :reduce="option => option.id"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
              />
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="from" name="from" rules=""
                                v-slot="{ errors }">
              <small class="label">From</small>
              <flat-pickr v-model="from" :config="{ dateFormat: 'd/m/Y'}" class="w-full"/>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="to" name="to" rules=""
                                v-slot="{ errors }">
              <small class="label">To</small>
              <flat-pickr v-model="to" :config="{ dateFormat: 'd/m/Y'}" class="w-full"/>
            </ValidationProvider>
          </div>
        </div>
        <div class="flex flex-wrap items-center justify-end mt-8">
          <vs-button class="ml-auto mt-2" button="submit" icon-pack="feather" icon="icon-download">Download</vs-button>
        </div>
      </form>
    </ValidationObserver>
  </vs-popup>

</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css'
import {RepositoryFactory} from "@/repository/RepositoryFactory";
import moment from "moment";
import SuccessMessage from "@/mixins/SuccessMessage";
import ErrorMessages from "@/mixins/ErrorMessages";

const FormulationsRepository = RepositoryFactory.get('formulations')
const CustomerRepository = RepositoryFactory.get('customer')
const ForeCastRepository = RepositoryFactory.get('forecast')
const DropDownRepository = RepositoryFactory.get('drop_down')
import {mapActions, mapGetters} from "vuex";

export default {
  name: "DownloadForecastDocumentPopUp",
  data(){
    return {
      open: false,
      customerId: 'all',
      customerLeadId: 'all',
      formulationId: 'all',
      from: '',
      to: '',
      formulations:[],
      customers:[],
    }
  },
  props: {
    filters: {
      required: true,
      default: () => { return {} }
    }
  },
  mixins: [SuccessMessage, ErrorMessages],
  methods:{
    ...mapActions(["fetchCustomerLeads"]),
    async openPopup(){
      await this.fetchFormulations()
      await this.fetchCustomers()
      await this.fetchCustomerLeads()
      await this.setInitialFilters()
      this.open = true
    },
    async setInitialFilters(){
      this.customerId = this.filters.customer_id || 'all'
      this.customerLeadId = this.filters.customer_lead_id || 'all'
      this.formulationId = this.filters.formulation_id || 'all'
      this.from = this.filters.from_date || moment().clone().startOf('year').format('DD/MM/YYYY')
      this.to = this.filters.to_date || moment().clone().endOf('year').format('DD/MM/YYYY')
    },
    async downloadExcel(){
      this.$vs.loading();
      try {
        const response = await ForeCastRepository.downloadExcelDocument(
          this.customerId === 'all' ? '' : this.customerId,
          this.customerLeadId === 'all' ? '' : this.customerLeadId,
          this.formulationId === 'all' ? '' : this.formulationId,
          this.from, 
          this.to
        )
        let fileURL = window.URL.createObjectURL(new Blob([response.data]));
        let fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', `forecast_report(${this.from} - ${this.to}).xlsx`);
        document.body.appendChild(fileLink);
        fileLink.click();
      }catch (error){
        this.$vs.loading.close()
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
    async fetchFormulations() {
      this.$vs.loading();
      try {
        const { data } = await DropDownRepository.getFormulationList()
        this.formulations = data.data
        this.formulations.unshift({ id: 'all', formulation_code: 'All' })
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
    async fetchCustomers() {
      this.$vs.loading();
      const {data} = await DropDownRepository.getCustomersList()
      this.customers = data.data
      this.customers.unshift({ id: 'all', company_name: 'All' })
      this.$vs.loading.close()
    },
  },
  components:{
    'v-select':vSelect,
    flatPickr
  },
  computed: {
    ...mapGetters(["customer_leads"]),
    customer_lead_list() {
      let lead_list = []
      Object.assign(lead_list, this.customer_leads)
      lead_list.unshift({ value: 'all', name: 'All' })
      return lead_list
    }
  }

}
</script>

<style scoped>

</style>
